export const IDENTIFICATION_LIST = [
  {
    id: 1,
    name: "Cédula",
    value: "Cedula"
  },
  {
    id: 2,
    name: "Pasaporte",
    value: "Pasaporte"
  },
  {
    id: 3,
    name: "RNC",
    value: "Rnc"
  }
];

const C_IDENTIFICATION = {
  CEDULA: {
    id: 1,
    name: "Cedula",
    value: "cedula",
    label: "Cédula"
  },
  PASAPORTE: {
    id: 2,
    name: "Pasaporte",
    value: "pasaporte",
    label: "Pasaporte"
  },
  RNC: {
    id: 3,
    name: "RNC",
    value: "rnc",
    label: "RNC"
  }
};

const A_IDENTIFICATION = [
  C_IDENTIFICATION.CEDULA,
  C_IDENTIFICATION.PASAPORTE
  // C_IDENTIFICATION.RNC,
];

const O_IDENTIFICATION = {
  [C_IDENTIFICATION.CEDULA.value]: C_IDENTIFICATION.CEDULA,
  [C_IDENTIFICATION.PASAPORTE.value]: C_IDENTIFICATION.PASAPORTE,
  [C_IDENTIFICATION.RNC.value]: C_IDENTIFICATION.RNC,
  [C_IDENTIFICATION.CEDULA.id]: C_IDENTIFICATION.CEDULA,
  [C_IDENTIFICATION.PASAPORTE.id]: C_IDENTIFICATION.PASAPORTE,
  [C_IDENTIFICATION.RNC.id]: C_IDENTIFICATION.RNC
};

export { C_IDENTIFICATION, A_IDENTIFICATION, O_IDENTIFICATION };
